import React, {useEffect, useState} from 'react';

interface CenteredGridLines {
    slideSize: {width: number; height: number};
}

function CenteredGridLines(props: CenteredGridLines): JSX.Element | null {
    const {slideSize} = props;
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onKey = (e: KeyboardEvent): void => {
            if (e.key === 'Control') setVisible(e.type === 'keydown');
        };
        document.addEventListener('keydown', onKey);
        document.addEventListener('keyup', onKey);
        return () => {
            document.removeEventListener('keydown', onKey);
            document.removeEventListener('keyup', onKey);
        };
    }, []);

    if (!visible) return null;

    return (
        <svg
            className="c-presGrid"
            width={slideSize.width}
            height={slideSize.height}
            viewBox={`0 0 ${slideSize.width} ${slideSize.height}`}
        >
            <line x1={slideSize.width / 2} x2={slideSize.width / 2} y1="0" y2={slideSize.height} stroke="orange" strokeWidth="1" />
            <line x1="0" x2={slideSize.width} y1={slideSize.height / 2} y2={slideSize.height / 2} stroke="orange" strokeWidth="1" />
        </svg>
    );
}

export default CenteredGridLines;
